module.exports = __webpack_public_path__ + "assets/icon_checkmark.ddc3cb30.svg";